import { createAction } from 'redux-actions';

export const GetDetailCompanyOrganizerRequested = createAction('GET_DETAIL_COMPANY_ORGANIZER_REQUESTED');
export const GetDetailCompanyOrganizerReceived = createAction('GET_DETAIL_COMPANY_ORGANIZER_RECEIVED');
export const GetDetailCompanyOrganizerReceivedFailure = createAction('GET_DETAIL_COMPANY_ORGANIZER_RECEIVED_FAILURE');
export const ClearGetDetailCompanyOrganizer = createAction('CLEAR_GET_DETAIL_COMPANY_ORGANIZER');

export const EditCompanyOrganizerRequested = createAction('EDIT_COMPANY_ORGANIZER_REQUESTED');
export const EditCompanyOrganizerReceived = createAction('EDIT_COMPANY_ORGANIZER_RECEIVED');
export const EditCompanyOrganizerReceivedFailure = createAction('EDIT_COMPANY_ORGANIZER_RECEIVED_FAILURE');
export const ClearEditCompanyOrganizer = createAction('CLEAR_EDIT_COMPANY_ORGANIZER');

export const GetCommonInfoCompanyRequested = createAction('GET_COMMON_INFO_COMPANY_REQUESTED');
export const GetCommonInfoCompanyRequestedReceived = createAction('GET_COMMON_INFO_COMPANY_REQUESTED_RECEIVED');
export const GetCommonInfoCompanyRequestedReceivedFailure = createAction('GET_COMMON_INFO_COMPANY_REQUESTED_RECEIVED_FAILURE');

export const GetDetailCompanyOrganizerForSideBarRequested = createAction('GET_DETAIL_COMPANY_ORGANIZER_FOR_SIDE_BAR_REQUESTED');
export const GetDetailCompanyOrganizerForSideBarReceived = createAction('GET_DETAIL_COMPANY_ORGANIZER_FOR_SIDE_BAR_RECEIVED');
export const GetDetailCompanyOrganizerForSideBarReceivedFailure = createAction('GET_DETAIL_COMPANY_ORGANIZER_FOR_SIDE_BAR_RECEIVED_FAILURE');
export const ClearGetDetailCompanyOrganizerForSideBar = createAction('CLEAR_GET_DETAIL_COMPANY_ORGANIZER_FOR_SIDE_BAR');
